import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import InfoPopover from 'Components/InfoPopover';
import HistoryHeader from 'Components/_NewElements/HistoryHeader';
import { formatPartialDate } from 'Utility/date';
import { mgc } from 'neuro-schemas';

const { calculateScore } = mgc;

const MGCHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <>
    <HistoryHeader
      headerText={<FormattedMessage id="functionalPerformanceMgravis.mgc" />}
      buttons={[{ text: 'functionalPerformanceMgravis.newMGC', onClick: startEdit({}, 'mgc') }]}
    />
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="functionalPerformanceMgravis.labels.mgc.score" />
          </Item>
          <Item xs={8}>&nbsp;</Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={2}>{formatPartialDate(d.date)}</Item>
          <Item xs={2}>{calculateScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}</Item>
          <Item xs={5}>&nbsp;</Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'mgc'>>;
  startEdit: StartEdit;
  view?: IView;
}

export default MGCHistory;
